import styled from "styled-components"
import theme from "styles/theme-main"
import { Tooltip } from "react-tippy"

export const StyledCloseIcon = styled.span`
  position: absolute;
  top: 15px;
  right: 15px;
  display: inline-block;
  width: 12.5px;
  height: 12.5px;
  text-align: center;
  color: ${theme.colors.textPrimary};
  cursor: pointer;
  transition: all 0.2s linear;
`

export const StyledTooltipIcon = styled.span`
  display: inline-block;
  width: ${props => (props.variant === "covid" ? "24px" : "12.5px")};
  height: ${props => (props.variant === "covid" ? "24px" : "12.5px")};
  text-align: center;
  color: ${props =>
    props.variant === "covid"
      ? props.theme.colors.danger
      : props.theme.colors.inactive};
  margin-left: 10px;
  padding: 0;
  cursor: pointer;
  transition: all 0.2s linear;
  border-radius: 7.5px;
 /* :hover {
    color: ${props => props.theme.colors.warning};
  }*/

  :focus-visible {
    outline: 2px solid #015ECC !important;
  }

`

export const StyledTooltip = styled(Tooltip)`
  z-index: 0;
`

export const TippyUL = styled.ul`
  padding-left: 20px;
  margin-top: 1px;
`

export const TippyLI = styled.li`
  padding-left: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.43;
  letter-spacing: 0.2px;
  color: ${theme.colors.textSecondary};
`

export const ToolTipContentContainer = styled.div`
  max-width: 275px;
`
